import { render } from '@testing-library/react';
import { act } from 'react-dom/test-utils';
/**
 * helper method to perform a render wrapped in a promise and act because the component we are rendering
 * asynchronously updates the state upon initial render which leads to big ugly (though harmless) warnings in the
 * console. By wrapping it all up in a promise like this appears to help due to the nature of how promises are
 * implemented in some sort of queue fashion or something...idk...but it appears to work for now.
 * @param ui
 */
export async function renderAsync(ui) {
  let result = undefined;
  await act(async () => {
    const renderResult = render(ui);
    result = {
      ...renderResult,
      rerenderAsync: async ui => {
        await act(async () => {
          renderResult.rerender(ui);
        });
      }
    };
  });
  if (!result) throw new Error('Did not get a result from render ¯\\_(ツ)_/¯');
  return result;
}

/** Promise compatible setTimeout; */
export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};